export function toNumber(number: string | null | undefined): number | null | undefined {
    if (number === undefined) {
        return undefined;
    }
    if (number == null) {
        return null;
    }
    return parseInt(number);
}
